/* Shared report search presentation; APEX keeps filtering and refresh ownership. */
(function (window, document) {
    'use strict';
    var lx = window.lx = window.lx || {};
    if (lx.settingsReports) return;
    var reports = '.lxp-settings-report,.communication-report,.lp-communication-report';
    var selections = {}, resizePending = false;

    function resizeNativeHeaders() {
        if (resizePending) return;
        resizePending = true;
        window.requestAnimationFrame(function () {
            resizePending = false;
            window.apex.jQuery(window).trigger('apexwindowresized');
        });
    }

    function trackSelection(options) {
        if (selections[options.regionId]) return selections[options.regionId];
        var count = 0, revision = 0;
        function render() {
            var status = document.getElementById(options.statusId);
            if (status) status.textContent = count + ' ' + options.selectedLabel;
            var remove = document.querySelector(options.removeSelector);
            if (remove) remove.disabled = count === 0;
        }
        function refresh() {
            var requestedRevision = revision;
            window.apex.server.process('CHECKBOX_CNT', {x01:options.collection}, {
                dataType:'text', success:function (value) {
                    value = Number(String(value).trim());
                    if (Number.isFinite(value) && value >= 0 && requestedRevision === revision) {
                        count = value; render();
                    }
                }
            });
        }
        var $ = window.apex.jQuery, namespace = '.lpSettingsSelection' + options.regionId;
        $(document).on('change' + namespace, '#' + options.regionId + ' input[name=f01]', function () {
            revision += 1;
            count = Math.max(0, count + (this.checked ? 1 : -1));
            render();
        }).on('apexafterrefresh' + namespace, '#' + options.regionId, refresh);
        selections[options.regionId] = {render:render, refresh:refresh};
        render();
        refresh();
        return selections[options.regionId];
    }

    function decorateSearch(report, title) {
        if (!report) return;
        var hr = document.documentElement.lang.indexOf('hr') === 0;
        var empty = report.querySelector('.a-IRR-noDataMsg');
        if (empty) {
            empty.setAttribute('role', 'status');
            var message = empty.querySelector('.a-IRR-noDataMsg-text');
            if (report.querySelector('.a-IRR-controlsCheckbox[data-setting="filter"]:checked')) {
                if (message) message.textContent = hr
                    ? 'Nema odgovarajućih zapisa. Promijenite pretraživanje ili uklonite filtre.'
                    : 'No matching records. Adjust your search or remove filters to see more.';
            } else if (message && !message.textContent.trim()) {
                message.textContent = hr ? 'Još nema zapisa.' : 'No records yet.';
            }
        }
        var search = report.querySelector('.a-IRR-controlGroup--search:not(.a-IRR-controlGroup--hidden) .a-IRR-search');
        var input = search && search.querySelector('input:not([type=hidden])');
        if (!input || !input.id) return;
        var heading = report.querySelector('.t-Region-title,.t-ContentBlock-title');
        if (!title && heading) {
            var headingText = heading.cloneNode(true);
            headingText.querySelectorAll('button,input,select,.t-Button,[role=button]').forEach(function (control) {
                control.remove();
            });
            title = headingText.textContent.trim();
        }
        if (!title) return;
        var label = search.parentElement.querySelector('.settings-report-search-label');
        if (!label) {
            label = document.createElement('label');
            label.className = 'settings-report-search-label';
            search.before(label);
        }
        label.htmlFor = input.id;
        label.textContent = (hr ? 'Pretraži: ' : 'Search ') + title.toLocaleLowerCase(hr ? 'hr' : 'en');
        input.setAttribute('aria-label', label.textContent);
    }

    function decorateRows(report, options) {
        if (!report) return;
        var hr = document.documentElement.lang.indexOf('hr') === 0, changed = false;
        function labelColumn(id, label) {
            report.querySelectorAll('th[id="' + id + '"]').forEach(function (heading) {
                heading.setAttribute('aria-label', label);
                heading.querySelectorAll('a').forEach(function (link) { link.setAttribute('aria-label', label); });
                if (id === options.editColumn && !heading.classList.contains('settings-column-action')) {
                    heading.classList.add('settings-column-action');
                    changed = true;
                }
            });
        }
        labelColumn(options.editColumn, hr ? 'Radnje' : 'Actions');
        (options.actions || []).forEach(function (action) { labelColumn(action.column, action.label); });
        report.querySelectorAll('.a-IRR-table tr').forEach(function (row) {
            var identity = row.querySelector(options.nameSelector);
            var name = identity && identity.textContent.trim();
            if (!name) return;
            row.querySelectorAll('td[headers]').forEach(function (cell) {
                var columns = cell.getAttribute('headers').split(/\s+/);
                if (columns.indexOf(options.editColumn) !== -1) {
                    if (!cell.classList.contains('settings-column-action')) changed = true;
                    cell.classList.add('settings-column-action');
                    cell.querySelectorAll('a').forEach(function (link) {
                        var label = (hr ? 'Uredi ' : 'Edit ') + name;
                        link.setAttribute('aria-label', label);
                        link.title = label;
                    });
                    cell.querySelectorAll('input[type=checkbox]').forEach(function (input) {
                        input.setAttribute('aria-label', (hr ? 'Odaberi ' : 'Select ') + name);
                        if (!input.closest('.lp-settings-select')) {
                            changed = true;
                            var target = document.createElement('label');
                            target.className = 'lp-settings-select';
                            input.before(target);
                            target.appendChild(input);
                        }
                        var rail = input.closest('.lxIrIcons'), slot = input.closest('label');
                        if (rail && slot.parentElement !== rail) slot = slot.parentElement;
                        if (rail && rail.firstElementChild !== slot) { rail.prepend(slot); changed = true; }
                    });
                }
                (options.actions || []).forEach(function (action) {
                    if (columns.indexOf(action.column) === -1) return;
                    cell.classList.add('settings-column-utility');
                    cell.querySelectorAll('a,[onclick]').forEach(function (control) {
                        control.setAttribute('aria-label', action.label + ': ' + name);
                        if (!control.title) control.title = action.label + ': ' + name;
                        if (control.tagName !== 'A' && control.tagName !== 'BUTTON') {
                            control.setAttribute('role', 'button');
                            control.tabIndex = 0;
                            if (!control.dataset.lpReportKeyboard) {
                                control.dataset.lpReportKeyboard = 'true';
                                control.addEventListener('keydown', function (event) {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        event.preventDefault();
                                        event.currentTarget.click();
                                    }
                                });
                            }
                        }
                    });
                });
            });
        });
        // Native fixed headers measured before the action rail gained its target size.
        if (changed) resizeNativeHeaders();
    }

    function decorateDetails(report, options) {
        if (!report) return;
        report.querySelectorAll(options.selector).forEach(function (content, index) {
            if (!content.textContent.trim() || content.closest('.lp-report-details')) return;
            var cell = content.closest('td'), row = content.closest('tr');
            var identity = cell && cell.querySelector(options.nameSelector);
            var name = identity ? identity.textContent.trim() : '';
            var selection = row && row.querySelector('input[type=checkbox]');
            var key = String(selection ? selection.value : index).replace(/[^a-z0-9_-]/gi, '-');
            var wrapper = document.createElement('div'); wrapper.className = 'lp-report-details';
            var toggle = document.createElement('button'); toggle.type = 'button';
            toggle.className = 'lp-report-details__toggle';
            if (!content.id) content.id = report.id + '-' + options.key + '-' + key;
            content.classList.add('lp-report-details__content');
            toggle.setAttribute('aria-controls', content.id);
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', options.showLabel + name);
            var icon = document.createElement('span');
            icon.className = 'far fawe-plus'; icon.setAttribute('aria-hidden', 'true');
            var label = document.createElement('span'); label.textContent = options.label;
            toggle.append(icon, label);
            content.before(wrapper); wrapper.append(toggle, content);
            toggle.addEventListener('click', function () {
                var open = toggle.getAttribute('aria-expanded') !== 'true';
                toggle.setAttribute('aria-expanded', String(open));
                toggle.setAttribute('aria-label', (open ? options.hideLabel : options.showLabel) + name);
                wrapper.classList.toggle('is-open', open);
                icon.className = 'far fawe-' + (open ? 'minus' : 'plus');
                resizeNativeHeaders();
            });
            resizeNativeHeaders();
        });
    }

    function decorate(root) {
        if (root.matches && root.matches(reports)) decorateSearch(root);
        root.querySelectorAll(reports).forEach(function (report) { decorateSearch(report); });
    }

    lx.settingsReports = {decorateSearch:decorateSearch, decorateRows:decorateRows,
        decorateDetails:decorateDetails, trackSelection:trackSelection};
    window.apex.jQuery(function () {
        decorate(document);
        window.apex.jQuery(document).off('apexafterrefresh.lpSettingsReports')
            .on('apexafterrefresh.lpSettingsReports', function (event) { decorate(event.target); });
    });
}(window, document));
